import { useLoaderData } from "react-router-dom";
import PageTransition from "./templateParts/PageTransition";
import renderModules from "./renderModules";

const SingleOpenRoles = () => {
  const { modules = [] } = useLoaderData();

  return <PageTransition>{renderModules(modules)}</PageTransition>;
};

export default SingleOpenRoles;
